// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

import "chartkick/chart.js"
import "flowbite/dist/flowbite.turbo.js";

// TODO: Remove this workaround once Turbo records scroll positions for history entries promoted from frames.
// It relies on internal Turbo APIs; keep festival_navigation_test.rb covering the expected behavior until then.
const saveCurrentScrollPosition = () => {
  Turbo.session.history.updateRestorationData({
    scrollPosition: { x: window.pageXOffset, y: window.pageYOffset }
  })
}

const updateScrollForVisit = () => {
  const visit = Turbo.navigator.currentVisit
  if (!visit?.willRender) return

  if (visit.action === "restore") {
    const { scrollPosition } = visit.restorationData
    if (scrollPosition) window.scrollTo(scrollPosition.x, scrollPosition.y)
  } else if (visit.action === "advance" && !visit.location.hash) {
    window.scrollTo(0, 0)
  }
}

document.addEventListener("turbo:before-visit", saveCurrentScrollPosition)
document.addEventListener("turbo:load", updateScrollForVisit)

const chartTheme = (chart) => {
  const styles = getComputedStyle(document.documentElement)
  const color = (name) => styles.getPropertyValue(`--app-${name}`).trim()
  const scales = {
    x: { ticks: { color: color("secondary") }, grid: { color: color("divider") }, title: { color: color("strong") } },
    y: { ticks: { color: color("secondary") }, grid: { color: color("divider") }, title: { color: color("strong") } }
  }

  if (chart.getOptions().library?.scales?.dailySales) {
    scales.dailySales = {
      ticks: { color: color("secondary") },
      grid: { drawOnChartArea: false },
      title: { color: color("strong") }
    }
  }

  if (chart.getElement().closest("[data-weekday-sales-chart]")) {
    scales.x.ticks.autoSkip = false
    scales.x.ticks.callback = function(value) {
      const label = this.getLabelForValue(value)
      return window.matchMedia("(max-width: 639px)").matches ? label.slice(0, 3) : label
    }
  }

  return {
    library: {
      font: { family: styles.fontFamily },
      scales,
      plugins: {
        legend: { labels: { color: color("ink") } },
        title: { color: color("ink") },
        tooltip: { backgroundColor: color("surface"), titleColor: color("ink"), bodyColor: color("strong"), borderColor: color("divider"), borderWidth: 1 }
      }
    }
  }
}

const deepMerge = (left, right) => {
  const output = { ...left }
  Object.entries(right).forEach(([key, value]) => {
    output[key] = value && typeof value === "object" && !Array.isArray(value)
      ? deepMerge(left?.[key] || {}, value)
      : value
  })
  return output
}

const themeCharts = () => {
  if (!window.Chartkick?.eachChart) return
  window.Chartkick.eachChart((chart) => chart.setOptions(deepMerge(chart.getOptions(), chartTheme(chart))))
}

window.addEventListener("theme:change", themeCharts)
document.fonts.ready.then(themeCharts)
document.addEventListener("turbo:load", () => requestAnimationFrame(themeCharts))
document.addEventListener("turbo:frame-load", () => requestAnimationFrame(themeCharts))

const hideFlowbiteDropdowns = () => {
  document.querySelectorAll("[data-dropdown-toggle]").forEach((toggle) => {
    const dropdownId = toggle.getAttribute("data-dropdown-toggle")
    if (!dropdownId) return

    const dropdown = document.getElementById(dropdownId)
    if (!dropdown) return

    dropdown.classList.add("hidden")
  })
}

document.addEventListener("turbo:before-cache", hideFlowbiteDropdowns)
